// @flow
import * as React from 'react';
import last from 'lodash/last';
import styled from 'styled-components';
import { withStyles } from '@material-ui/core/styles';

const Wrapper = styled.div`
  position: fixed;
  height: calc(
    100% - ${props => props.headerHeight}px -
      ${props => (props.bottomMenu ? 4.5 : 0)}rem -
      ${props => (props.newTranscriptInputVisibility ? 70 : 0)}px
  );
  overflow-y: auto;
  width: calc(100% - ${props => (props.sidebar ? 270 : 0)}px);
  -webkit-app-region: ${props => props.captionMode ? 'drag' : ''};
  scroll-behavior: smooth;
`;
const ScrollTarget = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const styles = {
  wrapper: {
    "&::-webkit-scrollbar": {
      display: 'none',
    }
  },
  scrollTarget: {
    "&::-webkit-scrollbar": {
      display: 'none',
    }
  }
}

type Props = {
  bottomMenu: boolean,
  classes: Object,
  children: React.Node,
  electronCaptionMode: boolean,
  fullScreen: boolean,
  lightView: boolean,
  newTranscriptInputVisibility: boolean,
  sidebar: boolean,
  transcriptsCurrent: Array<string>,
};

type State = {
  followingTranscript: boolean,
};

class ScribeScrollWithTranscript extends React.Component<
  Props,
  State
> {
  scrollableContainer: ?HTMLElement;

  constructor() {
    super();
    this.scrollableContainer = null;
    this.state = {
      followingTranscript: true,
    };
  }

  componentWillReceiveProps() {
    // If user was already at end of
    // the transcript we want to
    // keep following i.e. autoscroll
    if (this.scrollableContainer) {
      const isAtBottomOfTranscript =
        this.scrollableContainer.scrollTop >=
        this.scrollableContainer.scrollHeight -
          this.scrollableContainer.clientHeight -
          10;
      this.setState({
        followingTranscript: isAtBottomOfTranscript,
      });
    }
  }

  componentDidUpdate(prevProps: Props) {
    const {
      newTranscriptInputVisibility,
      electronCaptionMode,
    } = this.props;
    if (electronCaptionMode && !prevProps.electronCaptionMode) {
      /* eslint-disable-next-line react/no-did-update-set-state */
      this.setState({
        followingTranscript: true,
      });
    }
    if (
      this.scrollableContainer &&
      newTranscriptInputVisibility !== prevProps.newTranscriptInputVisibility
    ) {
      this.followIfShouldFollow();
      return;
    }
    const { transcriptsCurrent } = this.props;
    if (!last(transcriptsCurrent) || !last(prevProps.transcriptsCurrent))
      return;
    if (transcriptsCurrent.length !== prevProps.transcriptsCurrent.length) {
      this.followIfShouldFollow();
      return;
    }

    this.followIfShouldFollow();
  }

  followIfShouldFollow() {
    const { followingTranscript } = this.state;
    if (followingTranscript) {
      // setTimeout(..., 0) makes the browser execute the code directly after
      // this execution finishes. Without it the browser is not done rendering
      // the container and is unable to scroll it.
      setTimeout(() => {
        if (!this.scrollableContainer) return;
        this.scrollableContainer.scrollTop = this.scrollableContainer.scrollHeight;
      }, 0);
    }
  }

  render() {
    const {
      bottomMenu,
      classes,
      children,
      electronCaptionMode,
      fullScreen,
      lightView,
      newTranscriptInputVisibility,
      sidebar,
    } = this.props;
    return (
      <Wrapper
        className={electronCaptionMode ? classes.wrapper : ''}
        headerHeight={fullScreen || lightView ? 0 : 67}
        fullScreen={fullScreen}
        bottomMenu={bottomMenu}
        sidebar={sidebar}
        lightView={lightView}
        newTranscriptInputVisibility={newTranscriptInputVisibility}
        ref={el => {
          this.scrollableContainer = el;
        }}
        captionMode={window.isElectron && electronCaptionMode}
      >
        <ScrollTarget className={electronCaptionMode ? classes.scrollTarget : ''}>{children}</ScrollTarget>
      </Wrapper>
    );
  }
}

export default withStyles(styles)(ScribeScrollWithTranscript);